import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRoutingTracker } from '../../HOC/withRoutingTracker.js'
import Fabrics from './Fabrics.js'
import SingleFabric from './SingleFabric.js'
import FiltersView from './FiltersView.js'
import {
  setCanProceedToNextStep,
  setFabricDirection,
  setSelectedCordFabric,
  setSelectedFabric,
} from '../../actions/generalActions.js'
import {
  addPreselectedCordedFabric,
  addPreselectedFabric,
  getFabricsDataByName,
} from '../../actions/fabricsActions.js'
import { capitalizeString, isNumeric } from '../../utils/utils.js'
import StepTitle from '../StepTitle/index.js'

class CushionFabricSelector extends PureComponent {
  constructor(props) {
    super(props)
    const { history } = props
    const pathView = history?.location?.search?.split('=')?.pop()
    const view = isNumeric(pathView) ? 'single-fabric' : pathView

    this.state = {
      currentView: view || 'fabrics',
    }
  }

  async componentDidMount() {
    const { dispatch, params, general } = this.props
    const { id, direction, name } = params.fabric
    const { fabricDirection, enableScrollTo } = general
    let { fabric } = general

    if (!fabric) {
      const fabricsFromServer = await getFabricsDataByName(
        capitalizeString(name?.replaceAll('-', ' ')),
        dispatch,
      )
      fabric = fabricsFromServer?.find((f) => f?.id?.toString() === id?.toString())
      if (fabric) {
        dispatch(setSelectedFabric(fabric, true))
        dispatch(setSelectedCordFabric(fabric, true))
        if (direction) {
          dispatch(setFabricDirection(direction))
        }
        dispatch(addPreselectedFabric(fabric))
        dispatch(addPreselectedCordedFabric(fabric))
      }
    }

    const isDirectional =
      fabric?.attributes?.find((attr) => attr.name.toLowerCase() === 'is directional')
        ?.options[0] === 'yes'

    dispatch(
      setCanProceedToNextStep(
        (id !== 'fabric' && !!direction) ||
          (fabric && !isDirectional) ||
          (fabric && isDirectional && ['horizontal', 'vertical'].includes(fabricDirection)),
      ),
    )

    if (enableScrollTo === true) {
      scrollTo('site-header', 100)
    }
  }

  _switchCurrentView = (view) => (fabricId) => {
    const { history } = this.props

    if (fabricId && view === 'single-fabric') {
      history.push({
        pathname: history.location.pathname,
        search: `?viewing=${fabricId}`,
        state: { isActive: true },
      })
    }

    this.setState({ currentView: view })
  }

  _getCurrentView = () => {
    const { currentView } = this.state

    switch (currentView) {
      case 'fabrics':
        return <Fabrics switchCurrentView={this._switchCurrentView} />
      case 'single-fabric':
        return <SingleFabric switchCurrentView={this._switchCurrentView('fabrics')}/>
      case 'filters':
        return <FiltersView switchCurrentView={this._switchCurrentView('fabrics')} />
    }
  }

  render() {
    const { general, currentLocationIndex } = this.props

    return (
      <>
        <StepTitle
          name={general?.type?.name}
          step={currentLocationIndex - 1}
          attributes={general?.type?.attributes}
        />
        {this._getCurrentView()}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
  fabrics: state.fabrics,
})

export default withRoutingTracker(connect(mapStateToProps)(CushionFabricSelector))
